import { cn } from "@/lib/utils";
import { BadgeType } from "@/stores/slices/commonSlice";
import { FlameIcon } from "../fun-ui/icons";


type PriceBadgeProps = {
  label: string;
  badge: BadgeType;
  size?: 14 | 12;
  scale?: number;
  rounded?: boolean;
}
export function PriceBadge({
  label,
  badge = 'none',
  size = 14,
  scale = 1,
  rounded = false,
}: PriceBadgeProps) {
  if (!['normal', 'primary', 'hyper'].includes(badge)) {
    return <></>;
  }
  return (
    <div className={cn(
      "flex flex-row items-center",
      size === 14 && "font-semibold",
      "bg-[linear-gradient(250deg,var(--tw-gradient-stops))]",
      badge === 'normal' && "from-[#D3D7F1] to-[#F1F2F3] from-30% to-90% text-muted-foreground/70",
      badge === 'primary' && "from-[#FF8E0C] to-[#FFD95E] from-25% to-100% text-primary-foreground",
      badge === 'hyper' && "from-[#FF0C25] to-[#FF7943] from-25% to-100% text-primary-foreground",
    )}
      style={{
        borderBottomLeftRadius: `${6 * scale}px`,
        borderTopRightRadius: `${6 * scale}px`,
        padding: `${4 * scale}px ${10 * scale}px`,
        fontSize: `${(size === 14 ? 14 : 12) * scale}px`,
        lineHeight: `${(size === 14 ? 24 : 16) * scale}px`,
        ...(
          rounded ? {
            borderRadius: `${6 * scale}px`,
          } : {}
        )
      }}
    >
      {
        badge === 'hyper' ? (
          <FlameIcon size={size + 2} className="mr-1"></FlameIcon>
        ) : null
      }
      <span>{label}</span>
    </div>
  );
}